import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import * as Sound from './audio.js'

Vue.config.productionTip = false

// Vue.prototype.$Sound = Sound

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// .addEventListener('click', (evt) => {
//   if (evt.target.dontPlay) {
//     return
//   }
//   Sound.click.play()
// })

// Sound.bgm.once('load', () => {
//   Sound.bgm.play()
// })
